import BrowseByTitle from "@/features/browse-page/components/browse-by-title-page/BrowseByTitle";
import React from "react";

export const BrowseByTitlePage = () => {
  return (
    <div>
      <BrowseByTitle />
    </div>
  );
};
